import React, {useContext} from 'react'

export type ReportsTabContextProps = {
  setRenderer(index: number, renderer: () => React.ReactNode): void
  count: number
}

const ReportsTabContext = React.createContext<ReportsTabContextProps>(null as any)

export default ReportsTabContext

export function useReportsTabContext() {
  return useContext(ReportsTabContext)
}
